import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTodos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTodos"><Path d="M15.5 20.5H20.5V3.5H3.5V20.5H8.5M8.25 13.3L10.9773 15.75L15.75 8.75" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTodos;
